import { Grid, IconButton, Stepper as MuiStepper, Typography } from '@material-ui/core';
import styled from 'styled-components';

import colors from '../../styles/theme/colors';
import { sizes } from '../../styles/theme/devices';
import spaces from '../../styles/theme/spaces';
import MainLogo from '../molecules/Logo';

const Container = styled.header`
  align-items: flex-start;
  background-color: ${colors.default.white};
  display: flex;
  flex-direction: column;
  min-height: 40px;
  position: ${(props) => (props.propPositionFixed ? 'fixed' : 'initial')};
  top: ${(props) => (props.propPositionFixed ? '0' : 'initial')};
  width: 100%;
  z-index: 999;

  .MuiStepLabel-label.MuiStepLabel-active,
  .MuiStepIcon-root.MuiStepIcon-active {
    color: ${colors.primary.main} !important;
  }
  .MuiStepLabel-label.MuiStepLabel-completed,
  .MuiStepIcon-root.MuiStepIcon-completed {
    color: ${colors.green[500]};
  }
`;

const Wrapper = styled.div`
  width: 100%;

  @media (max-width: ${sizes.tablet}) {
    padding: 0;
  }
`;

const Row = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  padding: ${(props) =>
    props.size === 'large'
      ? `calc(${spaces.xs} - 6px) 0 calc(${spaces.xs} - 6px) ${spaces.xs}`
      : `${spaces.xs} 0 ${spaces.xs} ${spaces.xs}`};
  width: 100%;

  @media (min-width: 960px) {
    max-width: 768px;
    padding: 0;
  }

  @media (min-width: ${sizes.laptop}) {
    padding: 0 ${spaces.small};
  }
`;

const Logo = styled(MainLogo)`
  display: none;
  align-items: center;
  padding: calc(${spaces.xs} - 4px) ${spaces.xs};
  width: 100%;

  @media (min-width: 960px) {
    display: flex;

    img {
      height: auto;
      width: 88px;
    }
  }
`;

const BackButton = styled(IconButton)`
  margin-right: ${spaces.xs};
  padding: 0;
`;

const Title = styled(Typography)`
  display: ${(props) => (props.device === 'mobile' ? 'block' : 'none')};
  flex: 1;
  font-size: 14px;

  @media (min-width: 960px) {
    display: ${(props) => (props.device === 'desktop' ? 'block' : 'none')};
    font-size: 18px;
  }
`;

const Stepper = styled(MuiStepper)`
  flex: 2;
  padding: 0;

  @media (max-width: ${sizes.tablet}) {
    overflow-x: auto;
    padding: ${spaces.xs} 0;
    padding: 0;
    white-space: nowrap;

    .MuiStepConnector-root {
      margin: 0 calc(${spaces.xs} / 2);
      min-width: ${spaces.small};
    }

    .MuiStep-root {
      padding: 0;
    }

    .MuiStep-root:last-child {
      padding-right: ${spaces.xs};
    }
  }
`;

const ContainerHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 32px;

  @media (min-width: 960px) {
    padding: 0 152px;
  }
`;

const WrapperSelectLanguage = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
`;

const GridOrdered = styled(Grid)`
  padding-right: 8px;

  @media (min-width: 960px) {
    justify-content: center;
    order: 3;
  }
`;

export {
  BackButton,
  Container,
  GridOrdered,
  Logo,
  Row,
  Stepper,
  Title,
  Wrapper,
  WrapperSelectLanguage,
  ContainerHeader,
};
